import { HttpAgent } from '@ag-ui/client';

import { apiConfigHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

import { DEAL_ASSISTANT_CHAT_PATH } from '../constants';
import { createDealAssistantFetch } from './dealAssistantFetch';
import type { DealAssistantFetch } from './dealAssistantFetch';

export type CreateDealAssistantAgentParams = {
    getDealerId: () => number | undefined;
    baseFetch?: DealAssistantFetch;
    timeoutMs?: number;
};

export const createDealAssistantAgent = ({ getDealerId, baseFetch, timeoutMs }: CreateDealAssistantAgentParams): HttpAgent =>
    new HttpAgent({
        url: apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHrefUtil.getLocHref(), DEAL_ASSISTANT_CHAT_PATH).url,
        fetch: createDealAssistantFetch({ getDealerId, baseFetch, timeoutMs })
    });
